export const themes = {
    LIGHT: 'LIGHT',
    DARK: 'DARK',
};

export const types = {
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
};
